import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function HeroSlide() {
  return <div className="h-full w-full flex flex-col items-center justify-start md:justify-center text-center px-4 md:px-8 relative overflow-y-auto md:overflow-hidden bg-[#11166b] py-16 md:py-0" data-id="element-50">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-51">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#00d8a8]/10 rounded-full blur-3xl" data-id="element-52" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#00d8a8]/5 rounded-full blur-3xl" data-id="element-53" />
      </div>

      <motion.div initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="mb-6 md:mb-12 relative mt-8 md:mt-0" data-id="element-54">
        <div className="absolute inset-0 bg-[#00d8a8] blur-2xl opacity-20 rounded-full" data-id="element-55" />
        <Zap className="w-20 h-20 md:w-32 md:h-32 text-[#00d8a8] relative z-10" strokeWidth={1.5} data-id="element-56" />
      </motion.div>

      <motion.h1 initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.3,
      duration: 0.8
    }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 tracking-tight" data-id="element-57">
        <span className="text-[#00d8a8]" data-id="element-58">Smart Charging, Your Way</span>
      </motion.h1>

      <motion.p initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.5,
      duration: 0.8
    }} className="text-lg md:text-xl lg:text-2xl text-slate-300 max-w-3xl leading-relaxed pb-20 md:pb-0" data-id="element-59">
        Smart charging at home made simple for CPOs to scale
      </motion.p>
    </div>;
}